import { simboloMoneda } from '../services/negocioActual';

// Helpers PUROS del módulo de servicios (sin acceso a red/BD, fáciles de probar).
// El dinero se calcula con enteros de centavos para evitar errores de coma
// flotante (regla de oro de Kontrol: los reportes deben cuadrar).

// Modalidades de cobro de un servicio. Extensible: agregar una entrada aquí
// (y en el CHECK de la migración) sin tocar el resto del código.
export const MODALIDADES_PRECIO = [
  { clave: 'fijo', nombre: 'Precio fijo', sufijo: '' },
  { clave: 'desde', nombre: 'Desde (precio mínimo)', sufijo: '', prefijoEtiqueta: 'Desde ' },
  { clave: 'por_hora', nombre: 'Por hora', sufijo: ' / hora' },
  { clave: 'por_dia', nombre: 'Por día', sufijo: ' / día' },
  { clave: 'por_visita', nombre: 'Por visita', sufijo: ' / visita' },
  { clave: 'por_persona', nombre: 'Por persona', sufijo: ' / persona' },
  { clave: 'por_paquete', nombre: 'Por paquete', sufijo: ' / paquete' },
  { clave: 'por_proyecto', nombre: 'Por proyecto', sufijo: ' / proyecto' },
  { clave: 'cotizacion', nombre: 'Bajo cotización (sin precio fijo)', sufijo: '' },
];

// Modalidad de entrega del servicio.
export const MODALIDADES_SERVICIO = [
  { clave: 'presencial', nombre: 'Presencial', icono: '🏢' },
  { clave: 'remoto', nombre: 'Remoto', icono: '💻' },
  { clave: 'domicilio', nombre: 'A domicilio', icono: '🚗' },
  { clave: 'establecimiento', nombre: 'En establecimiento', icono: '🏪' },
  { clave: 'online', nombre: 'Online', icono: '🌐' },
  { clave: 'hibrido', nombre: 'Híbrido', icono: '🔀' },
];

// Unidades de duración.
export const UNIDADES_DURACION = [
  { clave: 'minutos', nombre: 'minutos' },
  { clave: 'horas', nombre: 'horas' },
  { clave: 'dias', nombre: 'días' },
  { clave: 'semanas', nombre: 'semanas' },
  { clave: 'meses', nombre: 'meses' },
];

export function modalidadPrecio(clave) {
  return MODALIDADES_PRECIO.find((m) => m.clave === clave) || MODALIDADES_PRECIO[0];
}

// Formatea un monto con la moneda del negocio (multi-país). El símbolo por
// defecto es 'L' (Honduras) pero se respeta la moneda que traiga el negocio.
export function formatoMoneda(monto, moneda = 'L') {
  const n = Number(monto) || 0;
  const simbolo = simboloMoneda(moneda || 'L');
  const formateado = n.toLocaleString('es-HN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `${simbolo} ${formateado}`;
}

// Etiqueta de precio para el catálogo, según la modalidad.
//   fijo → "L 1,500.00"
//   desde → "Desde L 1,500.00"
//   por_persona → "L 1,500.00 / persona"
//   cotizacion → "Bajo cotización"
export function etiquetaPrecio(servicio, monedaNegocio = 'L') {
  if (!servicio) return '';
  const mod = modalidadPrecio(servicio.modalidad_precio);
  if (mod.clave === 'cotizacion') return 'Bajo cotización';
  const moneda = servicio.moneda || monedaNegocio || 'L';
  return `${mod.prefijoEtiqueta || ''}${formatoMoneda(servicio.precio, moneda)}${mod.sufijo || ''}`;
}

// Precio final con impuesto (en centavos, sin errores de coma flotante).
// Devuelve { base, impuesto, total } en unidades de moneda (2 decimales).
export function calcularPrecioConImpuesto(precio, impuestoPct) {
  const baseCent = Math.round((Number(precio) || 0) * 100);
  const pct = Number(impuestoPct) || 0;
  const impuestoCent = Math.round((baseCent * pct) / 100);
  return {
    base: baseCent / 100,
    impuesto: impuestoCent / 100,
    total: (baseCent + impuestoCent) / 100,
  };
}

// Duración legible: "2 horas", "30 minutos", o '' si no está definida.
export function etiquetaDuracion(servicio) {
  if (!servicio || !servicio.duracion_valor) return '';
  const unidad = (UNIDADES_DURACION.find((u) => u.clave === servicio.duracion_unidad) || {}).nombre || '';
  const n = Number(servicio.duracion_valor);
  const num = Number.isInteger(n) ? String(n) : n.toFixed(2).replace(/\.?0+$/, '');
  return `${num} ${unidad}`.trim();
}
